import { createApp } from 'vue'
import App from '@/page/vue/2023/sandbox.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: 'ISC 2023创新独角兽沙盒大赛开启招募',
  desc: '聚力数字安全新竞界！点击参与报名',
  imgUrl: 'https://p1.ssl.qhimg.com/t019114be795542d00a.png',
  link: window.location.href
})

const app = createApp(App)
app.mount('#app')
